"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PanelCercadorMap = require("./PanelCercadorMap.css");

var _PanelCercadorMap2 = _interopRequireDefault(_PanelCercadorMap);

var _cercamuncom = require("./cercamuncom");

var _semanticUiReact = require("semantic-ui-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var dropdownOptions = [];

var PanelCercadorMap = function (_React$PureComponent) {
	_inherits(PanelCercadorMap, _React$PureComponent);

	//const [selection, setSelection] = useState([]);
	function PanelCercadorMap(props) {
		_classCallCheck(this, PanelCercadorMap);

		var _this = _possibleConstructorReturn(this, (PanelCercadorMap.__proto__ || Object.getPrototypeOf(PanelCercadorMap)).call(this, props));

		_this.viewFilterList = function () {
			var viewSearchBox = _this.state.viewSearchBox;

			_this.setState({ "viewSearchBox": viewSearchBox ? false : true });
		};

		_this.state = {
			viewSearchBox: false,
			fontsSetVal: [],
			fontsSet: [],
			selection: [],
			setSelection: []

		};

		return _this;
	}

	_createClass(PanelCercadorMap, [{
		key: "componentDidMount",
		value: function componentDidMount() {

			_cercamuncom.MUNICOMS.forEach(function (item, index) {
				dropdownOptions.push({
					key: index,
					text: item.title,
					value: item.bbox
				});
			});

			dropdownOptions = dropdownOptions.sort(function (a, b) {
				return a.text.toLowerCase().localeCompare(b.text.toLowerCase());
			});

			/*
   		if (this.props.infowindow.viewfiltersources && this.props.infowindow.viewfiltersources.length) {
   			this.setState({
   				loading: false,
   				fontsSetVal: this.props.infowindow.viewfiltersources || ""
   
   			});
   		}
   		*/
		}
	}, {
		key: "handleFontChange",
		value: function handleFontChange(event, dropdownData) {

			console.info(dropdownData);

			this.props.zoomToMap(dropdownData);

			/*
   const drowdownValues = (dropdownData.value instanceof Array) ? dropdownData.value : [dropdownData.value];
   this.props.updateInfowindowPropsAndUpdateMap("viewfiltersources", drowdownValues);
   this.setState({ fontsSetVal: drowdownValues });
   */
		}
	}, {
		key: "renderList",
		value: function renderList() {
			var _this2 = this;

			if (this.state.viewSearchBox == true) {

				return _react2.default.createElement(
					"div",
					{ className: _PanelCercadorMap2.default.cmdFilterButtons },
					_react2.default.createElement(_semanticUiReact.Dropdown, {
						fluid: true,
						className: _PanelCercadorMap2.default.smallFont,
						placeholder: "Cerca municipis",
						search: true,
						selection: true,
						options: dropdownOptions,
						onChange: function onChange(e, data) {
							return _this2.handleFontChange(e, data.value);
						},
						ref: function ref(instance) {
							return _this2.dropDown = instance;
						}
					})
				);
			} else {
				return _react2.default.createElement("div", null);
			}
		}
	}, {
		key: "renderButtons",
		value: function renderButtons() {

			if (this.props.infowindow.viewcercador && this.props.infowindow.viewcercador === true) {
				return _react2.default.createElement(
					"div",
					{ className: _PanelCercadorMap2.default.btCercadorButtons },
					_react2.default.createElement(_semanticUiReact.Icon, { onClick: this.viewFilterList, size: "large", name: "search" })
				);
			} else {
				return _react2.default.createElement("div", null);
			}
		}
	}, {
		key: "render",
		value: function render() {

			var panelStyle = this.props.isEditor ? _PanelCercadorMap2.default.PanelCercadorMap : _PanelCercadorMap2.default.PanelCercadorMapVisor;

			return _react2.default.createElement(
				"div",
				{ className: panelStyle, id: "panelInfo" },
				this.renderList(),
				this.renderButtons()
			);
		}
	}]);

	return PanelCercadorMap;
}(_react2.default.PureComponent);

exports.default = PanelCercadorMap;


PanelCercadorMap.propTypes = {
	infowindow: _propTypes2.default.object,
	zoomToMap: _propTypes2.default.func,
	isEditor: _propTypes2.default.bool
};
